import { IGiftPackagingBoxSettings } from '@model';

export const getImageFromBoxSettings = (boxes: IGiftPackagingBoxSettings[], productCode: string): string => {
  const box = boxes.find((b) => b.productCode === productCode);
  return box?.image ?? '';
};
